import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div>
          <a href="/contact" className="footer-link">Contact</a> |{' '}
          <a href="/about" className="footer-link">A propos</a>
        </div>
        <div>
          &copy; {new Date().getFullYear()} EcotoneAI. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
